import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle, BookOpen, Clock, Wind, Calendar, MessageCircle, Layout, HelpCircle } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
export function SalesOffer() {
  return <div className="bg-cream-100 relative" data-id="element-147">
      {/* Divider */}
      <div className="h-px w-full bg-cream-300" data-id="element-148" />

      {/* What You Get */}
      <section className="py-12 md:py-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-149">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="text-center mb-8 md:mb-12" data-id="element-150">
          <h2 className="text-2xl md:text-4xl font-bold text-ocean mb-2" data-id="element-151">
            Lo que obtienes hoy
          </h2>
          <p className="text-ink-500 text-sm md:text-lg" data-id="element-152">
            Un sistema completo, no solo teoría.
          </p>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} data-id="element-153">
          {[{
          icon: BookOpen,
          title: 'El Manual Completo (PDF — 20 capítulos)',
          desc: 'De los fundamentos de la mente hasta herramientas concretas y la visión que lo cambia todo.'
        }, {
          icon: Clock,
          title: 'El Reset de 15 segundos',
          desc: 'La secuencia exacta para salir del bloqueo después de un error — en lugar de quedarse atrapado en él.'
        }, {
          icon: Wind,
          title: 'Las 3 Técnicas de Respiración del Atleta',
          desc: '4-2-6 para reset, 5-5 para preparación, 2-1 para activación. Simples. Entrenables. Efectivas.'
        }, {
          icon: Calendar,
          title: 'El Protocolo de Reprogramación Diaria',
          desc: '5 minutos en la mañana + 5 en la noche. No intensidad — consistencia.'
        }, {
          icon: MessageCircle,
          title: 'La Guía de Conversaciones para Padres',
          desc: 'Qué decir antes de una competencia, después de un momento difícil y cuando el error pesa. Con frases exactas.'
        }, {
          icon: Layout,
          title: 'El Kit Mental del Atleta Joven',
          desc: 'Todas las herramientas en una sola página para usar desde hoy.'
        }, {
          icon: HelpCircle,
          title: 'La Autoevaluación del Padre',
          desc: '10 preguntas honestas para entender tu campo invisible — y cómo está afectando el de tu hijo.'
        }].map((item, i) => <motion.div key={i} variants={fadeIn} className="flex bg-white p-4 md:p-6 rounded-xl border border-cream-300" data-id="element-154">
              <item.icon className="w-5 h-5 md:w-6 md:h-6 text-slate-teal flex-shrink-0 mt-0.5 mr-3" data-id="element-155" />
              <div data-id="element-156">
                <h3 className="text-ocean font-bold mb-0.5 text-sm md:text-base" data-id="element-157">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-ink-500 leading-relaxed" data-id="element-158">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </section>

      {/* Who is this for / not for */}
      <section className="py-12 md:py-16 px-4 sm:px-6 lg:px-8 bg-cream-200/30" data-id="element-159">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-160">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-161">
            <h3 className="text-lg md:text-2xl font-bold text-ocean mb-4 flex items-center" data-id="element-162">
              <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-emerald-500 mr-2" data-id="element-163" />
              Para quién es
            </h3>
            <ul className="space-y-3" data-id="element-164">
              {['Padres de niños y jóvenes de 6 a 17 años que practican deporte.', 'Familias que entienden que el campo es un aula — y la vida real, el examen.', 'Padres que quieren herramientas reales basadas en ciencia, no motivación vacía.', 'Quienes están dispuestos a mirarse a sí mismos — no solo a corregir a su hijo.'].map((text, i) => <li key={i} className="flex items-start" data-id="element-165">
                  <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 mt-2 mr-2.5 flex-shrink-0" data-id="element-166" />
                  <span className="text-sm md:text-base text-ink-700" data-id="element-167">
                    {text}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-168">
            <h3 className="text-lg md:text-2xl font-bold text-ocean mb-4 flex items-center" data-id="element-169">
              <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-500 mr-2" data-id="element-170" />
              Para quién NO es
            </h3>
            <ul className="space-y-3" data-id="element-171">
              {['Padres que buscan resultados instantáneos sin cambiar nada en casa.', 'Quienes creen que el carácter se nace y no se construye.', 'Personas que no están dispuestas a revisar su propia reacción ante el error de su hijo.'].map((text, i) => <li key={i} className="flex items-start" data-id="element-172">
                  <div className="w-1.5 h-1.5 rounded-full bg-red-500 mt-2 mr-2.5 flex-shrink-0" data-id="element-173" />
                  <span className="text-sm md:text-base text-ink-700" data-id="element-174">
                    {text}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </section>

      {/* How it works */}
      <section className="py-12 md:py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-175">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="text-center mb-8 md:mb-12" data-id="element-176">
          <h2 className="text-2xl md:text-4xl font-bold text-ocean" data-id="element-177">
            Cómo funciona
          </h2>
        </motion.div>

        <div className="space-y-5 md:space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-cream-300" data-id="element-178">
          {[{
          step: '1',
          title: 'Entiende el juego invisible',
          desc: 'Descubres qué patrones mentales tiene tu hijo, cómo se formaron y por qué lo limitan.'
        }, {
          step: '2',
          title: 'Transforma tu campo',
          desc: 'Aprendes cómo tu presencia, palabras y energía construyen o erosionan su mentalidad.'
        }, {
          step: '3',
          title: 'Instala las herramientas',
          desc: 'Protocolos simples y diarios que crean identidad de atleta desde adentro hacia afuera.'
        }].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: i % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.2
        }} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-179">
              <div className="flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-slate-teal bg-cream-100 text-slate-teal font-bold text-sm md:text-base shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-180">
                {item.step}
              </div>
              <div className="w-[calc(100%-3.5rem)] md:w-[calc(50%-2.5rem)] bg-white p-4 md:p-6 rounded-xl border border-cream-300" data-id="element-181">
                <h3 className="font-bold text-ocean mb-1 text-sm md:text-base" data-id="element-182">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-ink-500" data-id="element-183">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </section>

      {/* Proof / Believability */}
      <section className="py-12 md:py-16 px-4 sm:px-6 lg:px-8 bg-cream-200/30" data-id="element-184">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="max-w-3xl mx-auto text-center" data-id="element-185">
          <p className="text-lg md:text-2xl text-[#4A90C4] mb-5 italic font-light leading-relaxed" data-id="element-186">
            "Este libro no promete un niño sin miedo. El miedo forma parte del
            deporte. Forma parte de la vida."
          </p>
          <p className="text-sm md:text-lg text-ink-500 mb-4" data-id="element-187">
            Lo que sí te va a dar es algo más valioso: las herramientas para que
            tu hijo aprenda a actuar a pesar de él. Para que el error no lo
            destruya. Para que el resultado de un partido no decida cómo se
            siente sobre sí mismo.
          </p>
          <p className="text-base md:text-xl text-ink-900 font-bold" data-id="element-188">
            Eso es valentía real. Y la valentía no se nace — se entrena.
          </p>
        </motion.div>
      </section>

      {/* FAQ */}
      <section className="py-12 md:py-16 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-189">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} data-id="element-190">
          <h2 className="text-2xl md:text-3xl font-bold text-ocean mb-6 md:mb-10 text-center" data-id="element-191">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-3 md:space-y-6" data-id="element-192">
            {[{
            q: '¿Necesito saber de fútbol?',
            a: 'No. Este manual es sobre psicología, neurociencia y crianza consciente aplicada al rendimiento.'
          }, {
            q: '¿A partir de qué edad sirve?',
            a: 'Desde los 6 años. La ventana de los 10 a 16 años es especialmente poderosa.'
          }, {
            q: '¿Cuándo veré resultados?',
            a: 'Al aplicar el Reset y cambiar una conversación después de un momento difícil, notarás cambios desde la primera semana.'
          }, {
            q: '¿Solo sirve para fútbol?',
            a: 'No. Se transfiere a exámenes, amistades y cualquier situación de presión en su vida.'
          }].map((faq, i) => <div key={i} className="bg-white p-4 md:p-6 rounded-lg border border-cream-300" data-id="element-193">
                <h4 className="text-ocean font-bold mb-1 text-sm md:text-base" data-id="element-194">
                  {faq.q}
                </h4>
                <p className="text-ink-500 text-xs md:text-sm" data-id="element-195">{faq.a}</p>
              </div>)}
          </div>
        </motion.div>
      </section>

      {/* Final Offer + CTA */}
      <section id="offer" className="py-12 md:py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-196">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="max-w-4xl mx-auto text-center relative z-10 bg-white p-6 md:p-12 rounded-2xl border border-cream-300 shadow-lg" data-id="element-197">
          <h2 className="text-2xl md:text-4xl font-bold text-ocean mb-4" data-id="element-198">
            El talento le permite entrar al campo.
            <br data-id="element-199" />
            <span className="text-slate-teal" data-id="element-200">
              Su mentalidad le permite quedarse en él.
            </span>
          </h2>

          <p className="text-sm md:text-lg text-ink-700 mb-6" data-id="element-201">
            Primero se forma la mente. Después se forma el atleta. No estás
            comprando un libro. Estás invirtiendo en la arquitectura mental que
            tu hijo va a usar los próximos 40 años de su vida.
          </p>

          <div className="mb-8" data-id="element-202">
            <p className="text-ink-500 mb-2 uppercase tracking-widest text-xs font-medium" data-id="element-203">
              Obtén El Juego Invisible hoy por solo
            </p>
            <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-204">
              <span className="text-lg md:text-xl text-ink-400 line-through" data-id="element-205">
                $27
              </span>
              <span className="text-3xl md:text-4xl font-semibold text-warm-orange tracking-tight" data-id="element-206">
                $6.39
              </span>
              <span className="text-xs font-semibold text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded-full" data-id="element-207">
                -76%
              </span>
            </div>
          </div>

          <motion.a href="https://myvitalexpansion.com/cart/44522453794900:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'AddToCart');
          }
        }} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block w-full sm:w-auto px-8 py-4 md:px-10 md:py-5 bg-warm-orange hover:bg-[#d45e24] text-white font-semibold rounded-xl text-lg md:text-xl transition-colors duration-300 uppercase tracking-wide text-center" data-id="element-208">
            Empezar Ahora
          </motion.a>

          <p className="mt-4 text-xs md:text-sm text-ink-500 flex items-center justify-center" data-id="element-209">
            <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5 text-slate-teal" data-id="element-210" />
            Acceso instantáneo. Formato Digital PDF.
          </p>
        </motion.div>
      </section>
    </div>;
}